export const transcriptionSettingsKeys = {
  all: [{ module: 'transcriptionSettings' }] as const,
  organization: (organizationId?: string) =>
    [{ module: 'transcriptionSettings', organizationId: organizationId ?? null }] as const,
};
